var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/calendar-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.80469 2.67969V5.67969",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8047 2.67969V5.67969",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.30469 9.77344H21.3047",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.8047 19.6797C22.8047 20.4297 22.5947 21.1397 22.2247 21.7397C21.5347 22.8997 20.2647 23.6797 18.8047 23.6797C17.7947 23.6797 16.8747 23.3097 16.1747 22.6797C15.8647 22.4197 15.5947 22.0997 15.3847 21.7397C15.0147 21.1397 14.8047 20.4297 14.8047 19.6797C14.8047 17.4697 16.5947 15.6797 18.8047 15.6797C20.0047 15.6797 21.0747 16.2097 21.8047 17.0397C22.4247 17.7497 22.8047 18.6697 22.8047 19.6797Z",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.2422 19.6831L18.2322 20.6731L20.3622 18.7031",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.8047 9.17969V17.0397C21.0747 16.2097 20.0047 15.6797 18.8047 15.6797C16.5947 15.6797 14.8047 17.4697 14.8047 19.6797C14.8047 20.4297 15.0147 21.1397 15.3847 21.7397C15.5947 22.0997 15.8647 22.4197 16.1747 22.6797H8.80469C5.30469 22.6797 3.80469 20.6797 3.80469 17.6797V9.17969C3.80469 6.17969 5.30469 4.17969 8.80469 4.17969H16.8047C20.3047 4.17969 21.8047 6.17969 21.8047 9.17969Z",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.7992 14.3828H12.8082",
    stroke: "#246BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M9.09607 14.3828H9.10505",
    stroke: "#246BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.09607 17.3828H9.10505",
    stroke: "#246BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTick);
export default __webpack_public_path__ + "static/media/calendar-tick.6893235e3180986a1d020f8967cd148e.svg";
export { ForwardRef as ReactComponent };